import React, { Fragment } from 'react';
import { Grid, List, ListItem, ListItemText, ListItemAvatar, Avatar, Divider } from '@material-ui/core';
import generateStyles from './styles';
import { NavLink } from 'react-router-dom';
import { withStyles } from '@material-ui/styles';
import SearchBar from '../../../../../components/shared/SearchBar';
import { Customer } from '../customer.model';
import { Skeleton } from '@material-ui/lab';

const Customers = (props: any) => {
    const { styles, match, sort } = props;
    let { customers } = props;
    const frags = match.url.split('/')
    frags.pop();
    let alpha = '_';
    // let alphaSelected: boolean;
    customers = customers.sort((a: any, b: any) => {
        if(a.companyName.toLowerCase() < b.companyName.toLowerCase() ) return sort === 'ASC' ? -1 : 1;
        if(a.companyName.toLowerCase() > b.companyName.toLowerCase() ) return sort === 'ASC' ? 1 : -1;
        return 0;
    });

    if(customers[0] === 0) {
        return (
            <h4 style={{textAlign: 'center'}}>Loading....</h4>
        )
    }

    if(customers.length === 0) {
        console.log('here!')
        return (
            <h4 style={{textAlign: 'center'}}>No customers found!</h4>
        )
    }

    return customers.map((customer: any, index: any) => {
        const url = match.url.endsWith('/customers') ? `${match.url}` : frags.join('/');
        if(customer){
            if(alpha.toLowerCase() !== customer.companyName.charAt(0).toLowerCase()) {
                alpha = customer.companyName.charAt(0).toUpperCase();
                // alphaSelected = true;
            } else {
                alpha = customer.companyName.charAt(0).toUpperCase();
                // alphaSelected = false;
            }
        }

        return(
            <Fragment key={Math.random()}>
            {/* {
                alphaSelected && index!== 0
                ?
                    <Divider style={{margin: '20px 0'}}/>
                :
                    <Fragment></Fragment>
            }
            { alphaSelected
                ?
                    <h3 style={{paddingLeft: 20, color: '#3293E9', margin: '0 0 5px 0'}}>{alpha}</h3>
                :
                    <Fragment></Fragment>
            } */}
            {
                customer
                ?
                    <NavLink className={styles.customer} key={customer.id} to={`${url}/${customer.id}`} activeClassName={styles.activeLink}>
                        {/* <ListItem className='bt' button></ListItem> */}
                        <ListItem className='bt' button>
                            <ListItemAvatar>
                                <Avatar>
                                    { alpha }
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                                primary={customer.companyName}
                            />
                        </ListItem>
                    </NavLink>
                :
                    <Fragment></Fragment>
            }
            </Fragment>
        )
    });
}

class CustomerList extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            sort: 'ASC',
            customers: [0],
            filteredCustomers: [0]
        };
    }

    componentDidUpdate() {
        if(this.props.customers[0] && this.props.match.url.endsWith('/customers')) {
            this.props.history.push(`${this.props.match.url}/${this.props.customers[0].id}`);
        }

        if(this.props.customers[0] !== 0 && this.state.customers[0] === 0) {
            this.setState({
                customers: this.props.customers,
                filteredCustomers: this.props.customers
            });
        }
    }

    toggleSort = () => {
        this.setState({
            sort: this.state.sort === 'ASC' ? 'DESC' : 'ASC'
        });
    }

    search = (text: string) => {
        const customers = this.state.customers.filter((customer: Customer) => customer.companyName.toLowerCase().includes(text.toLowerCase().trim()))
        this.setState({
            filteredCustomers: customers
        })
    }

    render() {
        const {classes} = this.props;
        // console.log(this.props);
        const {customers, ...props} = this.props;
        console.log(props)
        return (
            <Grid className={classes.list}>
                <div className={classes.searchNAdd}>
                    <SearchBar className={classes.search} searchText="Search Customer..." addBtnLink='/dashboard/customer/new' searchFunction={this.search}/>
                </div>
                <div className={classes.customerHeader}>
                    <h3>Customers</h3>
                    <div style={{display:"flex"}}>
                        {/* <TextField
                            InputProps={{disableUnderline: true}}
                            // labelId="demo-simple-select-label"
                            // label="Age"
                            id="demo-simple-select"
                            value={'all'}
                            // onChange={handleChange}
                            select
                            SelectProps={{IconComponent: () => <ExpandMoreIcon />}}
                        >
                            <MenuItem value={'all'}>All</MenuItem>
                            <MenuItem value={20}>Twenty</MenuItem>
                            <MenuItem value={30}>Thirty</MenuItem>
                        </TextField> */}
                        <div>
                        <img src="/img/sort.png" alt="sort icon" onClick={this.toggleSort} style={{width:"10px", marginTop:"10px", cursor:"pointer" }}/></div>
                    </div>
                </div>
                <List className={classes.customerList}>
                    {
                        this.state.filteredCustomers[0] !== 0
                        ?
                            <Customers sort={this.state.sort} styles={classes} {...props} customers={this.state.filteredCustomers} />
                        :
                        <Fragment key={Math.random()}>
                            <div style={{paddingLeft: 25, marginBottom: 10}}>
                                <Skeleton variant="text" width={20}/>
                            </div>
                            <ListItem className='bt' button style={{backgroundColor: '#eee'}}>
                                <ListItemAvatar>
                                    <Skeleton variant="circle" width={40} height={40} />
                                </ListItemAvatar>
                                <ListItemText>
                                    <Skeleton variant="text"/>
                                </ListItemText>
                            </ListItem>
                            <ListItem className='bt' button style={{backgroundColor: '#eee'}}>
                                <ListItemAvatar>
                                    <Skeleton variant="circle" width={40} height={40} />
                                </ListItemAvatar>
                                <ListItemText>
                                    <Skeleton variant="text"/>
                                </ListItemText>
                            </ListItem>
                            <ListItem className='bt' button style={{backgroundColor: '#eee'}}>
                                <ListItemAvatar>
                                    <Skeleton variant="circle" width={40} height={40} />
                                </ListItemAvatar>
                                <ListItemText>
                                    <Skeleton variant="text"/>
                                </ListItemText>
                            </ListItem>
                            <Divider style={{margin: '20px 0'}}/>
                            <div style={{paddingLeft: 25, marginBottom: 10}}>
                                <Skeleton variant="text" width={20}/>
                            </div>
                            <ListItem className='bt' button style={{backgroundColor: '#eee'}}>
                                <ListItemAvatar>
                                    <Skeleton variant="circle" width={40} height={40} />
                                </ListItemAvatar>
                                <ListItemText>
                                    <Skeleton variant="text"/>
                                </ListItemText>
                            </ListItem>
                        </Fragment>
                    }
                </List>
            </Grid>
        );
    }
};

export default withStyles(generateStyles())(CustomerList);